import { TFunction } from 'i18next';
import { InstalledBaseNodeType, InstalledBaseNodeTypeKey } from '../codegen/graphql';

// Resolves the display name for an installed base node type. The backend returns
// "Client" for the CLIENT key; we surface it as "Company" across the UI.
export const getInstalledBaseNodeTypeName = (
    nodeType: Pick<InstalledBaseNodeType, 'key' | 'name'> | null | undefined,
    t: TFunction,
): string => {
    if (!nodeType) return '';
    if (nodeType.key === InstalledBaseNodeTypeKey.CLIENT) return t('Company');
    return nodeType.name ?? '';
};
